<template>
  <div class="purchase-block f-column-b mt-5" :style="computedHeightStyle">
    <block-head
      :title="title"
      :type-list="jcTypeList"
      :icon="icon"
      :more-btn-url="moreBtnUrl"
      @change="jcTypeChange"
    />
    <div class="block-head">
      <ul v-if="!hidTab" class="f-start-c flex-1">
        <li
          v-for="nt in noticeTypeList"
          :key="nt[code]"
          class="fc99 mr-17"
          :class="{ active: nt[code] === activeType }"
          @click="changeNoticeType(nt[code])"
        >
          {{ nt[label] }}
        </li>
      </ul>
    </div>
    <div class="list">
      <el-table
        v-if="list.length"
        class="project-table"
        height="100%"
        :data="list"
        fit
        :default-sort="{ prop: 'endTime', order: null }"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        @sort-change="handleSortChange"
        @row-click="rowClick"
      >
        <el-table-column label="项目名称" min-width="180" header-align="center">
          <template slot-scope="{ row }">
            <div class="text-cut" :title="row.gonggaoTitle">
              <span v-if="row.systemFrom === 'eip'" class="color-theme-red"
                >[自主采购]</span
              >
              {{ row.gonggaoTitle }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="purchaseWayName"
          label="采购方式"
          width="210"
          align="center"
        />
        <el-table-column
          prop="startTime"
          label="公告时间"
          width="240"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.startTime | parseTime("{y}-{m}-{d}") }}</span>
          </template>
        </el-table-column>
        <!--        <el-table-column v-if="!hidColumns.includes('endTime')" prop="endTime" label="截止时间" width="240" align="center" />-->
        <el-table-column
          v-if="!hidColumns.includes('status')"
          label="项目状态"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span
              class="table-btn"
              :style="{
                backgroundColor: ['1', '3'].includes(scope.row.status)
                  ? '#DC4B19'
                  : '#999',
              }"
              >{{ scope.row.status_name }}</span
            >
          </template>
        </el-table-column>
      </el-table>
      <no-data v-else :no-txt="noTxt" :no-img="noImg" :text="$attrs.text" />
    </div>
  </div>
</template>

<script>
import {
  getConstantDic,
  INFO_TYPE_OPTIONS,
  PROJECT_STATUS_OPTIONS,
  PROJECT_TYPE_OPTIONS,
  SELECT_OPTION_CONFIG,
} from "@/utils/constant";
import purchaseApi from "@/api/purchase";
import NoData from "@/components/NoData.vue";
import BlockHead from "@/views/home/components/BlockHead.vue";

export default {
  name: "MaterialProcurement",
  components: { BlockHead, NoData },
  props: {
    defaultParams: {
      type: Object,
      default: () => ({}),
    },
    icon: {
      type: String,
      default: "purchase",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    hidTab: {
      type: Boolean,
      default: false,
    },
    // 需要隐藏的 column
    hidColumns: {
      type: Array,
      default: () => [],
    },
    // 模块高度
    blockHeight: {
      type: [Number, String],
      default: "522px",
    },
    // 最多显示多少行
    rows: {
      type: [Number, String],
      default: 8,
    },
    noTxt: {
      type: Boolean,
      default: true,
    },
    noImg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jcTypeList: [
        { code: "", label: "全部" },
        { code: "gangj", label: "钢筋" },
        { code: "shuin", label: "水泥" },
        { code: "liq", label: "沥青" },
        { code: "yuns", label: "运输" },
        { code: "laow", label: "劳务" },
        { code: "peij", label: "配件" },
        { code: "qit", label: "其他" },
      ],
      jcType: "",
      noticeTypeList: getConstantDic(INFO_TYPE_OPTIONS),
      // 项目状态  未开始：0 报名中：1 报名截止：2 公示中：3 公示结束 ：4 已中标：5 已废标：6）
      statusList: Object.values(PROJECT_STATUS_OPTIONS),
      noticeType: "",
      code: SELECT_OPTION_CONFIG.CODE,
      label: SELECT_OPTION_CONFIG.LABEL,
      list: [],
      orderType: "default",
      projectType: "JCCG",
    };
  },
  // 监听属性 类似于data概念
  computed: {
    moreBtnUrl() {
      return this.$router.resolve({
        path: "/purchase/list/xmxx",
        query: {
          noticeType: this.noticeType,
          projectType: this.projectType,
          ...this.defaultParams,
        },
      })?.href;
    },
    activeType() {
      return this.noticeType || "";
    },
    computedHeightStyle() {
      let height = this.blockHeight;
      if (typeof this.blockHeight === "string") {
        height = height.replace("px", "");
      }
      return { height: height + "px" };
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList();
  },
  // 方法集合
  methods: {
    jcTypeChange(code) {
      this.jcType = code;
      this.getList();
    },
    changeNoticeType(code) {
      this.noticeType = code;
      this.getList();
    },
    // 获取列表
    getList() {
      const params = {
        pageNo: 1,
        pageSize: this.rows,
        noticeType: this.noticeType,
        projectType: this.projectType,
        jcType: this.jcType,
        orderType: this.orderType || "default", // (默认：default  报名截止时间升序：baoMingEndDate_up 报名截止时间降序：baoMingEndDate_down)
        ...this.defaultParams,
      };
      purchaseApi.page(params).then((res) => {
        if (res.code === 0) {
          const data = res.data || {};
          const list = data.list || [];
          this.total = data.total || 0;
          list.forEach((e) => {
            e.status_name = this.statusList.find(
              (f) => f.code === e.status
            ).label;
          });
          this.list = data.list || [];
        }
      });
    },
    headerCellStyle() {
      return "background-color: #f9f9f9;padding: 4px 0;";
    },
    cellStyle({ columnIndex, rowIndex }) {
      let str = "padding: 9px 0;cursor:pointer;";
      if (columnIndex === 4) {
        str += "display: flex;justify-content: center;";
      }
      if (rowIndex === 7) {
        str += "border: none;";
      }
      return str;
    },
    // 行点击
    rowClick(row) {
      const route = this.$router.resolve({
        path: "/purchase/detail/xmxx",
        query: {
          id: row.id,
          infoid: row.infoid,
          noticeType: this.noticeType || this.defaultParams.noticeType,
        },
      });
      window.open(route.href);
    },
    // 排序
    handleSortChange({ order }) {
      this.orderType =
        order === "descending"
          ? "baoMingEndDate_down"
          : order === "ascending"
          ? "baoMingEndDate_up"
          : "default";
      this.getList("0");
    },
  },
};
</script>

<style scoped lang="scss">
.block-head {
  margin: 16px 0 0 0;
  ul > li {
    cursor: pointer;
    &.active {
      color: $--color-primary;
      font-weight: bold;
    }
    &:hover {
      color: $--color-primary;
    }
  }
}
.purchase-block {
  width: 100%;

  .list {
    flex: 1;
    min-height: 0;
    border: 1px solid #ddd;
    margin-top: 18px;
    .project-table {
      &::before {
        height: 0;
      }
      .table-btn {
        display: inline-block;
        width: 70px;
        height: 24px;
        color: #fff;
        text-align: center;
      }
    }
  }
}
</style>
